import styled from "styled-components";
import { Page } from "../../style/default";

export const MyPage = styled(Page)`
  @media (max-width: 800px) {
    flex-direction: column;
  }
`;

export const LoginImage = styled.div`
  width: 350px;
  height: 100vh;
  background-image: linear-gradient(300deg, #3d5869 0%, #19262e 100%);
  padding: 1.5rem;

  > img {
    max-width: 70%;
    margin: 0 auto;
    display: block;
  }
  > div {
    display: flex;
    flex-direction: column;
    justify-content: center;

    @media (min-width: 800px) {
      margin-top: 5rem;
    }

    > h3 {
      color: var(--white);
      text-align: center;
    }

    > span {
      color: var(--white);
      font-size: 14px;
      margin-bottom: 0.6rem;
      margin-left: 1rem;
    }
    > ul {
      > li {
        color: var(--white);
        font-size: 14px;
        margin-bottom: 0.3rem;
      }
    }
  }

  @media (max-width: 800px) {
    width: 100%;
    height: 400px;

    justify-content: center;
  }
`;
export const LoginForm = styled.form`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  justify-items: center;
  background-color: var(--white);

  @media (max-width: 800px) {
    width: 100%;
  }

  > label {
    color: var(--sidebar);
    width: 50%;
    margin: 0 auto;
    margin-bottom: 0.5rem !important;
  }

  > input {
    border: none !important;
    padding: 0.6rem;
    width: 50%;
    margin: 0 auto;
    background-color: #e8f0fe;
    margin-bottom: 1rem;
  }

  > button {
    height: 45px;
    padding: 0.7rem 1.5rem;
    background-image: linear-gradient(162deg, #3d5869 0%, #283b47 100%);
    align-self: center;
    color: var(--white);
    border-radius: 5px;
    transition: filter 0.3s ease;
    font-weight: 600;
    font-size: 16px;

    &:hover {
      filter: brightness(1.5);
    }
  }
`;

export const ForgotContainer = styled.div`
  margin-top: 15px;
  text-align: center;
  > a {
    margin-left: 5px;
  }
`;
